import React from "react";

import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";

import TransactionsTable from "../Transactions/TransactionsTable";

interface BusinessInterestSectionProps {
  sectionHelper: SectionToggleState;
  namespace: string;
  masterBusinessId: string;
}

export const BusinessTransactionsSection: React.FC<
  BusinessInterestSectionProps
> = ({ sectionHelper, namespace, masterBusinessId }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.TRANSACTIONS,
  );

  return (
    <TransactionsTable
      isOpen={isOpen}
      namespace={namespace}
      masterBusinessId={masterBusinessId}
      onToggle={onToggle}
    />
  );
};
